import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/pages/index'
import Thankyou from '@/components/pages/thankyou'
import login from '@/components/pages/login'
import loginDashboard from '@/components/view/login/login.vue'
import offerUserList from '@/components/view/offerUsersList/offerUserList.vue'
import ChangePassword from '@/components/view/changePassword/ChangePassword.vue'
import couponCode from '@/components/view/userCoupon/couponCode.vue'
import Dashboard from '@/components/view/dashboard/dashboard.vue'




import scanPage from "@/components/pages/scan"
import couponStatus from "@/components/pages/couponStatus"
import user from "@/components/pages/user"
Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/thankyou',
    name: 'Thankyou',
    component: Thankyou,
    discount: 0
  }, {
    path: '/auth/callback',
    component: {
      template: '<div class="auth-component"></div>'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/scan',
    name: 'scanPage',
    component: scanPage
  },
  {
    path: '/coupon-status',
    name: 'CouponStatus',
    component: couponStatus,
    couponcode: ''
  },
  {
    path: '/user',
    name: 'user',
    component: user
  },
  {
    name: 'Login Dashboard',
    path: '/login-dashboard',
    // path: '/applogin',
    component: loginDashboard,
  },
  // {
  //     path: '*',
  //     redirect: '/dashboard',
  //     meta: {
  //         auth: true
  //     }
  // },
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: {
      auth: true
    }
  },
  {
    name: 'offerUserList',
    path: '/offerUserList',
    component: offerUserList,
    meta: {
      auth: true
    }
  },
  {
    name: 'Change Password',
    path: '/changePassword',
    component: ChangePassword,
    meta: {
      auth: true
    }
  },
  {
    name: 'User Coupon',
    path: '/couponlist',
    component: couponCode,
  },


  //import all sidebar items route
  ...getSidebarRoutes(),
  ]
})



function getSidebarRoutes(menu = [], routes = [], isBaseRouting = true) {
  if (menu.length < 1 && isBaseRouting) {
    const {
      sideBarItems
    } = require('../sidebar');
    menu = sideBarItems || [];
  }

  for (let i = 0, l = menu.length; i < l; i++) {
    const item = menu[i]
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      //since we are pushing items in array we don't need to return this fucntion. 
      getSidebarRoutes(item.children, routes, false);
    }
  }
  return routes
}


// WEBPACK FOOTER //
// ./src/router/index.js